// extracted by mini-css-extract-plugin
export var header = "_gx-0";